import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { registerAccount } from './api';
import { REGISTER } from './constants';


/**
 *
 * @param actionObject
 * @returns {IterableIterator<PutEffect<RouterAction>>}
 */
function* register(actionObject) {
    const serverResponse = yield registerAccount(actionObject.form);
    if(serverResponse){
        yield put( push('/login') );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRegister() {
    yield takeEvery(REGISTER, register);
}

export default watchRegister;
